<template>
  <div class="column medium-8 small-12">
    <h3>{{ translations.selectedTopUp }}</h3>
    <div class="small__package" style="background-image: url(/images/paket-bg-n.png);">
        <h2 v-if="type">{{ type.amount }}</h2>
        <div class="small__package-box">
          <p>{{ translations.validity }} {{ type.validDays }} {{ translations.days }}</p>
        </div>
    </div>
    <div class="text-with-icon"><img src="/icons/svg/mobile-purple.svg" alt=""><span>{{ translations.enterSmsCode }}</span></div>
    <div class="error" v-show="error">{{ error }}</div>
    <div class="input">
        <div class="form__item form__item--text">
          <label for="">{{ translations.smsCode }}</label>
          <input type="text" v-model="code" :placeholder="translations.smsCode">
        </div>
    </div>
    <a @click="cancel" class="button -hollow" :title="translations.backToMsisdnEntry" :aria-label="translations.backToMsisdnEntry">{{ translations.backToMsisdnEntry }}</a>
    <a @click="challengeResponse" class="button" :title="translations.confirm" :aria-label="translations.confirm">{{ translations.confirm }}</a>
  </div>
</template>

<script>
import api from '../apiAccess.js'

export default {
  name: 'EnterCode',
  props: ['translations', 'msisdn', 'node', 'type'],
  data () {
    return {
      error: null,
      msg: '',
      code: null
    }
  },
  methods: {
    challengeResponse() {
      // 051832242
      api.challengeResponse(this.msisdn, this.code, this.node)
      .then(challengeResponse => {
        if (challengeResponse.status === true) {
          let token = challengeResponse.response.token
          // console.log('redirect to... + ' + token)
          if (token) {
            let lang = document.documentElement.lang.toLowerCase()
            api.getVoucher(this.type.id, 'https://' + window.location.hostname + this.translations.urls.finalRelativeUrlSuccess, 'https://' + window.location.hostname + this.translations.urls.finalRelativeUrlError, token, lang)
            .then(r => {
              if (r && r.status === true) {
                localStorage.setItem('msisdn', this.msisdn)
                localStorage.setItem('token', token)
                localStorage.setItem('voucherId', r.response.id)
                window.location.href = r.response.redirect
              }
              else if (r && r.status === false) {
                this.error = r.message
              }
              else {
                this.error = r
              }
            })
          }
        } else if (challengeResponse && challengeResponse.status === false) {
          this.error = this.translations.incorrectCodeError
        }
      })
      .catch(e => {
        this.error = e === 'no MSISDN supplied' || e === 'code must be 5 chars' ? this.translations.incorrectCodeError : this.translations.systemError;
        this.$emit('error', e )
        console.error(e)
      })
    },
    cancel() {
      this.$emit('moveToNumber')
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/EnterCode.vue